export function UsersService ({socket}) {

    const events = new andy.EventManager();

    const dataset = new andy.Dataset('andy.admin.users');
    
    return  {
        dataset,
        on: events.addEventListener
    }
}